// https://hgoebl.github.io/mobile-detect.js/doc/MobileDetect.html
import MobileDetect from 'mobile-detect';
import { getLocalStorage, setLocalStorage } from '../localStorages';
import { generateRandomString } from './string';

export const getMobileDetect = (userAgent?: string): MobileDetect => {
  return new MobileDetect(userAgent || window.navigator.userAgent);
};

export const checkIsMobile = (userAgent?: string): boolean => {
  return !!getMobileDetect(userAgent).mobile();
};

export const checkIsTablet = (userAgent?: string): boolean => {
  return !!getMobileDetect(userAgent).tablet();
};

export const checkIsWebView = (userAgent?: string): boolean => {
  const md = getMobileDetect(userAgent);
  return (
    md.match(/webview|wv|ip((?!.*Safari)|(?=.*like Safari))/i) ||
    md.match(
      new RegExp(
        `(${[
          'WebView',
          '(iPhone|iPod|iPad)(?!.*Safari)',
          'Android.*(;\\s+wv|Version/\\d.\\d\\s+Chrome/\\d+(\\.0){3})',
          'Linux; U; Android',
        ].join('|')})`,
        'ig'
      )
    )
  );
};

export const checkIsStandalone = (): boolean => {
  return (
    (window.navigator as any)?.standalone ||
    window.matchMedia('(display-mode: standalone)').matches
  );
};

export const handleUniqueDeviceId = () => {
  let uniqueDeviceId = getLocalStorage('UniqueDeviceId');

  if (!uniqueDeviceId) {
    uniqueDeviceId = generateRandomString(32);
    setLocalStorage('UniqueDeviceId', uniqueDeviceId);
  }

  return uniqueDeviceId;
};
